import { consulta_de_vagas_por_ensino_e_bairro } from "./consulta-de-vagas-por-ensino-e-bairro";
import { consulta_de_vagas_por_escolas } from "./consulta-de-vagas-por-escolas";
import { consulta_historico_de_vagas_por_escola } from "./consulta-historico-de-vagas-por-escola";

const consulta_de_vagas = [
  consulta_de_vagas_por_escolas,
  consulta_historico_de_vagas_por_escola,
  consulta_de_vagas_por_ensino_e_bairro,
];

export { consulta_de_vagas };
